import { toUkTimezoneDate } from '../../../utils/date'

import {
  BIRDVIEW_RELATIVE_TIME_NOW_KEY,
  BIRDVIEW_RELATIVE_TIME_UNITS,
} from './BirdviewRowRelativeTime.constants'

export function getBirdviewRelativeTimeInfo({ date, now, timeZone }) {
  const from = toUkTimezoneDate(date, timeZone)

  return (
    BIRDVIEW_RELATIVE_TIME_UNITS.map(({ getDifference, key }) => ({
      count: getDifference(now, from),
      key,
    })).find(({ count }) => count > 0) ?? {
      key: BIRDVIEW_RELATIVE_TIME_NOW_KEY,
    }
  )
}
